<h2
  class="lg:mt-6 xs:mt-1 py-4 text-center text-3xl leading-9 font-extrabold text-[#7B68EE]"
>
  My Order
</h2>

<div class="mx-3 sm:mx-5 lg:mx-24">
  <div class="flex flex-wrap items-center gap-2">
    <span class="w-full text-lg font-semibold sm:w-auto sm:text-xl">Sort By:</span>
    <select
      id="pricingType"
      name="pricingType"
      (change)="selectFilter($event)"
      class="h-10 max-w-full border-2 border-purple-700 focus:outline-none focus:border-purple-500 text-black rounded px-2 py-0 tracking-wider"
    >
      <option value="All" class="text-xl font-semibold bg-purple-700" selected>
        All Order
      </option>
      <option value="New">Not Shipped</option>
      <option value="Cancelled">Cancelled</option>
      <option value="Delivered">Delivered</option>
    </select>

    <span class="text-lg font-semibold sm:text-xl sm:ml-2"
      >Order Time:</span
    >
    <select
      (change)="selectMonth($event)"
      class="h-10 border-2 border-purple-700 rounded px-2"
    >
      <option value="All" selected>Month</option>
      <option value="1">January</option>
      <option value="2">February</option>
      <option value="3">March</option>
      <option value="4">April</option>
      <option value="5">May</option>
      <option value="6">June</option>
      <option value="7">July</option>
      <option value="8">August</option>
      <option value="9">September</option>
      <option value="10">October</option>
      <option value="11">November</option>
      <option value="12">December</option>
    </select>

    <select
      (change)="selectYear($event)"
      class="h-10 border-2 border-purple-700 rounded px-2"
    >
      <option value="All" selected>Year</option>
      <option *ngFor="let year of orderYears" [value]="year">
        {{ year }}
      </option>
    </select>
    <button
      (click)="resetFilters()"
      class="h-10 bg-purple-700 text-white rounded px-3 hover:bg-purple-600"
    >
      Reset Filters
    </button>
  </div>
</div>

<div *ngIf="userOrder.length > 0; else nouserOrder">
  <div
    class="flex flex-col justify-start items-start md:items-center bg-white py-2 w-full"
    *ngFor="let order of userOrder; trackBy: trackByOrderId"
  >
    <div
      class="mx-3 my-0 mb-8 flex w-[calc(100%-1.5rem)] max-w-6xl flex-col items-start justify-start rounded-lg border-2 border-purple-700 md:mx-auto md:flex-row md:items-center"
      *ngFor="let product of order.items; trackBy: trackByProductId"
    >
      <div class="flex w-full">
        <div
          class="flex w-full min-w-0 flex-col items-start justify-between space-y-4 pb-4 md:flex-row md:space-y-0 md:p-3"
        >
          <!-- Product Image -->
          <div
            class="m-auto w-full max-w-48 shrink-0 cursor-pointer object-contain p-3 md:max-w-40"
            (click)="getProductById(order._id)"
          >
            <img
              [src]="mycartListImageUrl + (product?.displayImage || '')"
              alt="Product image"
              class="w-full h-auto max-h-48 object-contain"
            />
          </div>

          <!-- Product Details -->
          <div
            class="flex w-full min-w-0 cursor-pointer flex-col items-start justify-start space-y-4 md:flex-1"
            (click)="getProductById(order._id)"
          >
            <div
              class="flex justify-start lg:my-6 items-start flex-col space-y-2"
            >
              <p class="break-words text-purple-700 text-xl font-semibold">
                {{ product?.name }}
              </p>
              <p class="text-black text-lg font-normal">
                Order on {{ product?.createdAt | date: "dd MMM yyyy" }}
              </p>
              <p class="text-black text-xl font-bold">
                Rs. {{ order?.total_amount }}
              </p>
              <p class="text-black text-xl font-medium">
                Quantity: {{ product?.quantity }}
              </p>
              <p
                class="text-purple-500 border border-purple-400 px-4 rounded-lg text-xl font-medium"
                *ngIf="order.userReturn === true"
              >
                ✅ Order Return
              </p>
            </div>
          </div>

          <!-- Product Variants -->
          <div class="flex w-full flex-wrap items-start justify-start gap-x-5">
            <div class="flex items-center lg:my-8 w-fit">
              <span class="text-center font-semibold w-auto">
                {{
                  product?.displayColor || order?.productColor
                    ? product?.displayColor || order?.productColor
                    : ""
                }}
                {{
                  (product?.displayColor || order?.productColor) &&
                  (product?.displaySize || order?.productSize)
                    ? " / "
                    : ""
                }}
                {{
                  product?.displaySize || order?.productSize
                    ? product?.displaySize || order?.productSize
                    : ""
                }}
              </span>
            </div>
          </div>

          <!-- Order Status Section -->
          <div class="flex w-full flex-wrap items-start gap-x-5 lg:justify-end">
            <div class="flex items-left lg:my-6 rounded-lg">
              <ng-container
                *ngIf="order.order_status === 'Cancelled'; else notCancelled"
              >
                <svg
                  class="w-8 h-8"
                  xmlns="http://www.w3.org/00/svg"
                  fill="#ee1111"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                  ></path>
                </svg>
                <div>
                  <p class="mx-1 break-words text-base font-bold text-red-500 sm:text-lg">
                    Cancelled On {{ product?.createdAt | date: "dd MMM yyyy"
                    }}<br />
                    <span class="text-sm font-normal text-black"
                      >Your item has been cancelled</span
                    ><br />
                  </p>
                  <!-- <div class="w-full">
                    <button
                      class="btncolor mx-auto rounded-lg p-4 m-5 bg-purple-700 text-white hover:bg-purple-600 font-medium"
                      (click)="trackOrder(order.items[0].waybillNumber)"
                    >
                      Track Order
                    </button>
                  </div> -->
                </div>
              </ng-container>

              <ng-template #notCancelled>
                <svg
                  class="w-8 h-8"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 512 512"
                  xml:space="preserve"
                  fill="#000000"
                >
                  <ellipse
                    style="fill: rgb(97, 60, 228)"
                    cx="256"
                    cy="256"
                    rx="256"
                    ry="255.832"
                  ></ellipse>
                  <polygon
                    style="fill: #ffffff"
                    points="235.48,392.08 114.44,297.792 148.84,253.616 223.176,311.512 345.848,134.504 391.88,166.392"
                  ></polygon>
                </svg>
                <div>
                  <p
                    class="mx-1 break-words text-base font-bold sm:text-lg"
                    [ngClass]="{
                      'text-purple-700': order.order_status === 'New',
                      'text-green-500': order.order_status === 'Delivered',
                    }"
                  >
                    Order On {{ product?.createdAt | date: "dd MMM yyyy"
                    }}<br />
                    <span class="text-sm font-normal text-black">
                      {{
                        order.order_status === "New"
                          ? "Your order has been placed"
                          : order.order_status === "intransit"
                            ? "Your item is on the way"
                            : order.order_status === "Delivered"
                              ? "Your order has been delivered"
                              : ""
                      }} </span
                    ><br />
                  </p>
                  <div class="flex w-full flex-wrap items-center justify-start gap-2 md:justify-end">
                    <button
                      class="btncolor my-2 rounded-lg bg-purple-700 p-3 text-white hover:bg-purple-600 font-medium sm:p-4"
                      (click)="
                        trackOrder(order.items[0].waybillNumber, product)
                      "
                    >
                      Track Order
                    </button>

                    <div class="relative inline-block text-left ml-2">
                      <button
                        (click)="
                          toggleMenu(order._id); $event.stopPropagation()
                        "
                        class="threedot inline-flex h-10 w-10 shrink-0 justify-center rounded-full p-2 hover:bg-gray-200"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="rotate-vertical h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                          />
                        </svg>
                      </button>

                      <div
                        *ngIf="activeMenu === order._id"
                        class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
                      >
                        <div class="py-1" role="menu">
                          <button
                            (click)="openDialog(order); activeMenu = null"
                            *ngIf="
                              !isOrderOlderThan7Days(order.createdAt) &&
                              order.userReturn === false
                            "
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                            role="menuitem"
                          >
                            Cancel Order
                          </button>
                          <button
                            (click)="
                              getProductById(order._id); activeMenu = null
                            "
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                            role="menuitem"
                          >
                            View Details
                          </button>
                          <button
                            *ngIf="
                              !isOrderOlderThan7Days(order.createdAt) &&
                              order.userReturn === false &&
                              order.order_status === 'Delivered'
                            "
                            (click)="retunOrder(order._id); activeMenu = null"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                            role="menuitem"
                          >
                            Return Order
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoadingMore" class="w-full flex justify-center py-8">
    <div
      class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-700"
    ></div>
  </div>

  <!-- End of Results Message -->
  <div
    *ngIf="!hasMoreItems && userOrder.length > 0"
    class="w-full text-center py-6 text-gray-500"
  >
    You've viewed all your orders
  </div>
</div>

<ng-template #nouserOrder>
  <div class="m-auto text-center">
    <div
      class="no-file-found flex flex-col items-center justify-center py-8 px-4 text-center bg-white rounded-lg"
    >
      <svg
        viewBox="0 -1 22 22"
        class="w-28 h-28 text-gray-700"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="#6f6d6d"
        stroke="#6f6d6d"
      >
        <path
          d="M346.000448,3018 C346.000448,3018.552 345.552448,3019 345.000448,3019 L341.000448,3019 C340.448448,3019 340.000448,3018.552 340.000448,3018 C340.000448,3017.448 340.448448,3017 341.000448,3017 L345.000448,3017 C345.552448,3017 346.000448,3017.448 346.000448,3018 L346.000448,3018 Z M337.000448,3005 L331.000448,3005 L331.000448,3004 C331.000448,3002.346 332.346448,3001 334.000448,3001 C335.654448,3001 337.000448,3002 337.000448,3004 L337.000448,3005 Z M340.694448,3007.859 L341.714448,3015 L343.734448,3015 L342.551448,3006.717 C342.410448,3005.732 341.566448,3005 340.571448,3005 L339.000448,3005 L339.000448,3004 C339.000448,3001 336.757448,2999 334.000448,2999 C331.243448,2999 329.000448,3001.243 329.000448,3004 L329.000448,3005 L327.735448,3005 C326.739448,3005 325.590448,3005.732 325.449448,3006.717 L324.020448,3016.717 C323.848448,3017.922 324.783448,3019 326.000448,3019 L338.000448,3019 L338.000448,3017 L327.153448,3017 C326.545448,3017 326.077448,3016.461 326.163448,3015.859 L327.306448,3007.859 C327.377448,3007.366 327.799448,3007 328.296448,3007 L329.000448,3007 L329.000448,3009 C329.000448,3009.552 329.448448,3010 330.000448,3010 C330.552448,3010 331.000448,3009.552 331.000448,3009 L331.000448,3007 L337.000448,3007 L337.000448,3009 C337.000448,3009.552 337.448448,3010 338.000448,3010 C338.552448,3010 339.000448,3009.552 339.000448,3009 L339.000448,3007 L339.704448,3007 C340.201448,3007 340.623448,3007.366 340.694448,3007.859 L340.694448,3007.859 Z"
        ></path>
      </svg>
      <h3 class="text-xl font-medium mt-4 text-gray-700">Buy product Now!</h3>
      <p class="text-xs font-medium mt-1 text-purple-700">Add item now</p>
    </div>
  </div>
</ng-template>
